"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var USE_CLASSES = {
  default: '',
  dark: 'private-tool-bar--dark',
  'filter-bar': 'private-tool-bar--with-filters',
  tabs: 'private-tool-bar--with-tabs'
};

var UIToolBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIToolBar, _Component);

  function UIToolBar() {
    (0, _classCallCheck2.default)(this, UIToolBar);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIToolBar).apply(this, arguments));
  }

  (0, _createClass2.default)(UIToolBar, [{
    key: "render",
    value: function render() {
      // `title` blacklisted here since `UIAbstractPageTemplate` expects one in CustomRenderer
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          __title = _this$props.title,
          use = _this$props.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "title", "use"]);

      var childCount = _react.Children.count(children);

      if (use === 'filter-bar' && childCount > 2) {
        _devLogger.default.warn({
          message: 'UIToolBar: More than 2 UIToolBarGroup items in a filter-bar is not recommended',
          key: 'UIToolBar: too many children for filter-bar'
        });
      }

      if (childCount > 3) {
        _devLogger.default.warn({
          message: 'UIToolBar: More than 3 UIToolBarGroup items are not recommended',
          key: 'UIToolBar: too many children in toolbar'
        });
      }

      return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
        className: (0, _classnames.default)('private-tool-bar', className, USE_CLASSES[use]),
        role: "group"
      }), _react.default.createElement("div", {
        className: "private-tool-bar__inner"
      }, children));
    }
  }]);
  return UIToolBar;
}(_react.Component);

exports.default = UIToolBar;
UIToolBar.propTypes = {
  children: _propTypes.default.node,
  title: _propTypes.default.string,
  use: _propTypes.default.oneOf(Object.keys(USE_CLASSES))
};
UIToolBar.displayName = 'UIToolBar';
module.exports = exports.default;